import * as React from "react";
import { CustomButton, ButtonType, Modal, ModalSize, ModalBody, CustomSubmitButton, ModalFooter, Form, HiddenInput } from "soprasteria-ui-library/dist";
import { MunicipalityModel } from '../../../api/UserApi';
import { IUserType, useAuth } from "../../../App";
import { useHistory } from "react-router";

interface IConfirmMunicipalitySelectionModal {
    selectedMunicipality: MunicipalityModel;
}

export const ConfirmMunicipalitySelectionModal: React.FunctionComponent<IConfirmMunicipalitySelectionModal> = ({ selectedMunicipality }) => {
    const auth = useAuth();

    const setMunicipalityAndRole = (data: MunicipalityModel) => {
        auth.setUserRolesGroup(data.roleGroupId.toString(), IUserType.Municipality);
        document.getElementById("close-confirm-municipality-selection-modal")?.click();
    }

    const renderDistrict = (districtName?: string) => {
        if (districtName) {
            return " - " + districtName;
        } else {
            return "";
        }
    }

    return (
        <Modal modalSize={ModalSize.small} id="confirm-municipality-selection-modal" header="Bekräfta val av roll">
            <Form onSubmit={setMunicipalityAndRole}>
                <ModalBody>
                    <HiddenInput value={selectedMunicipality.roleGroupId.toString()} name="roleGroupId" />
                    <p>Du kommer kopplas till kommun {selectedMunicipality.municipalityName}{renderDistrict(selectedMunicipality.districtName)}</p>
                </ModalBody>
                <ModalFooter>
                    <div role="group">
                        <CustomButton buttonType={ButtonType.general} id="close-confirm-municipality-selection-modal" data-dismiss="modal" buttonText="Avbryt" />
                        <CustomSubmitButton>Ok</CustomSubmitButton>
                    </div>
                </ModalFooter>
            </Form>
        </Modal>
    );

}
